import { useEffect, useRef, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { isFunction } from "@cayuse/shared-react.utils.type-checks";

export const useConfirmNavigation = (onBlock, onConfirm, onCancel, shouldBlock = false) => {
	const history = useHistory();
	const unblock = useRef(null);
	const doNavigation = useRef(null);

	useEffect(() => {
		if (isFunction(unblock.current)) {
			unblock.current();
		}

		if (shouldBlock) {
			unblock.current = history.block(targetLocation => {
				doNavigation.current = () => {
					if (isFunction(unblock.current)) {
						unblock.current();
					}

					history.push(targetLocation);
				};

				if (isFunction(onBlock)) {
					onBlock();
				}

				return false;
			});
		} else {
			doNavigation.current = null;
		}
	}, [ history, onBlock, shouldBlock ]);

	const confirm = useCallback(() => {
		if (isFunction(onConfirm)) {
			onConfirm();
		}

		if (isFunction(doNavigation.current)) {
			doNavigation.current();
		}

		doNavigation.current = null;
	}, [ onConfirm ]);

	const cancel = useCallback(() => {
		if (isFunction(onCancel)) {
			onCancel();
		}

		doNavigation.current = null;
	}, [ onCancel ]);

	return { confirm, cancel };
};